import { ApiResponseType, Maybe } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { OrganizationType } from '@/bundle/_Opco/types/types';
import { BillingProfileType } from '@/api/v1/users/getSelfUserDetailsApi';

type OpcoBillingProfileType = {
  billing_profile: Maybe<Pick<BillingProfileType, 'current_plan' | 'subscription'>>;
  active_users_count: number;
  is_msa_confirmed: boolean;
};

export type OpcoOrganizationDetailsType = OrganizationType & OpcoBillingProfileType;

export const getOrganizationApi = async (
  organizationId: string
): Promise<ApiResponseType<OpcoOrganizationDetailsType>> => {
  const uri = `/opco/organizations/${organizationId}/`;

  return authApiService.GET(uri);
};
